import { Locale } from 'modules/i18n';

export const translation = {
  [Locale.en]: {
    inputLabel: 'Amount {token}',
    receiveLabel: 'You receive {token}',
  },
};
